<template>
  <div v-if="data">
    <div class="flex break-inside-avoid flex-col items-center">
      <div class="pt-20 pb-10">
        <BaseMemberAvatars
          size="160"
          :members="membersWithAvatars"
          class="bg-surface-container-lowest"
        />
      </div>
      <div>
        <h1 class="text-display-medium text-center">Dialog</h1>
        <div class="text-body-large text-on-surface-variant flex flex-col items-center pt-4">
          <span
            >{{ $t('common.coach') }}: {{ data.dialog.coach.firstName }}
            {{ data.dialog.coach.lastName }}
          </span>

          <span>
            {{ $t('common.coachees') }}: {{ data.dialog.coachee.firstName }}
            {{ data.dialog.coachee.lastName }}
          </span>
          <span>
            {{ data.organizationName }}
          </span>
        </div>
      </div>
      <div class="pt-10">
        <BaseChip>
          {{ $t(`dialog.phases.${data.dialog.phase}`) }}
        </BaseChip>
      </div>
      <div class="flex max-w-lg flex-row flex-wrap justify-center gap-0.5 pt-3">
        <BaseChip icon="share">
          Freigegeben:
          <span v-if="data.dialog.coacheeDataReleasedAt">
            {{
              useDisplayDate(data.dialog.coacheeDataReleasedAt, {
                dayName: 'none',
                displayYear: 'always',
                monthName: 'short',
              })
            }}
          </span>
          <span v-else> - </span>
        </BaseChip>
        <BaseChip v-if="data.dialog.coachDataReleasedAt" icon="share">
          Coach-Freigabe:
          {{
            useDisplayDate(data.dialog.coachDataReleasedAt, {
              dayName: 'none',
              displayYear: 'always',
              monthName: 'short',
            })
          }}
        </BaseChip>
        <BaseChip icon="acute">
          Geplant:
          <span v-if="data.dialog.plannedAt">
            {{
              useDisplayDate(data.dialog.plannedAt, {
                dayName: 'none',
                displayYear: 'always',
                monthName: 'short',
              })
            }}
          </span>
          <span v-else> - </span>
        </BaseChip>
        <BaseChip icon="today">
          Durchgeführt:
          <span v-if="data.dialog.conductedAt">
            {{
              useDisplayDate(data.dialog.conductedAt, {
                dayName: 'none',
                displayYear: 'always',
                monthName: 'short',
              })
            }}
          </span>
          <span v-else> - </span>
        </BaseChip>
      </div>
    </div>
    <div v-for="slide in data.slides" :key="slide.feedbackTopic.id" class="break-before-page">
      <div class="flex flex-row items-center pb-4">
        <BaseIcon v-if="slide.feedbackTopic.icon" size="32" class="mr-3">{{
          slide.feedbackTopic.icon
        }}</BaseIcon>
        <h2 class="text-headline-large">{{ slide.feedbackTopic.title }}</h2>
      </div>
      <PrintJournalSlide
        v-if="slide.type === FeedbackTopicType.Journal"
        :feedback-topic="slide.feedbackTopic"
        :latest-value="slide.analysis.latestValue"
        :progress="slide.analysis.progress"
        :questions="slide.analysis.questions"
        :scale="slide.analysis.scale"
      />
      <PrintEvaluationSlide
        v-if="slide.type === FeedbackTopicType.Evaluation"
        :feedback-topic="slide.feedbackTopic"
        :skill-data="slide.skillData"
        :scale="slide.scale"
        :strengths="slide.strengths"
        :potentials="slide.potentials"
        :overestimates="slide.overestimates"
        :underestimates="slide.underestimates"
        :texts="slide.texts"
      />
      <PrintPulseSlide
        v-if="slide.type === FeedbackTopicType.Pulse"
        :feedback-topic="slide.feedbackTopic"
        :questions="slide.questions"
      />
      <PrintComments
        v-if="slide.comments.length > 0"
        :comments="slide.comments"
        :members="membersWithAvatars"
      />
      <PrintObjectives
        v-if="
          slide.objectives.createdObjectives.length > 0 ||
          slide.objectives.ongoingObjectives.length > 0
        "
        :created-objectives="slide.objectives.createdObjectives"
        :ongoing-objectives="slide.objectives.ongoingObjectives"
      />
    </div>
    <PrintDialogEndPage
      :coachee="data.dialog.coachee"
      :coach="data.dialog.coach"
      :organization-name="data.organizationName"
    />
  </div>
</template>
<script lang="ts" setup>
  import BaseChip from '@/core/components/base/chip/BaseChip.vue'
  import { usePrintDialog } from '../composable/use-print-dialog'
  import { useDisplayDate } from '@/core/composables/use-display-date'
  import PrintJournalSlide from '../components/print/PrintJournalSlide.vue'
  import { FeedbackTopicType } from '@/core/models/feedback-topic'
  import PrintEvaluationSlide from '../components/print/PrintEvaluationSlide.vue'
  import PrintPulseSlide from '../components/print/PrintPulseSlide.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import PrintComments from '../components/print/PrintComments.vue'
  import BaseMemberAvatars from '@/core/components/base/avatar/BaseMemberAvatars.vue'
  import { computed } from 'vue'
  import PrintObjectives from '../components/print/PrintObjectives.vue'
  import PrintDialogEndPage from './PrintDialogEndPage.vue'

  const { data } = usePrintDialog()

  const membersWithAvatars = computed(() => {
    const result = []
    for (const member of [data.value?.dialog.coach, data.value?.dialog.coachee]) {
      if (!member) {
        continue
      }
      result.push({
        ...member,
        avatarFileContent: data.value?.memberAvatars.find((avatar) => avatar.memberId === member.id)
          ?.fileContent,
      })
    }
    return result
  })
</script>
